import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";

import Layout from "./site/Layout";
import { PARTNER_LINK } from "./site/ui";
import Home from "./site/pages/Home";
import Partnership from "./site/pages/Partnership";
import Funding from "./site/pages/Funding";
import Services from "./site/pages/Services";
import WebsiteService from "./site/pages/WebsiteService";
import ConsultingService from "./site/pages/ConsultingService";
import TechService from "./site/pages/TechService";
import Works from "./site/pages/Works";
import Process from "./site/pages/Process";
import About from "./site/pages/About";
import Forum from "./site/pages/Forum";
import ForumPost from "./site/pages/ForumPost";
import ForumLayout from "./site/pages/ForumLayout";
import Products from "./site/pages/Products";
import ProductDetail from "./site/pages/ProductDetail";
import Cart from "./site/pages/Cart";
import Checkout from "./site/pages/Checkout";
import My from "./site/pages/My";
import Contact from "./site/pages/Contact";
import Privacy from "./site/pages/Privacy";
import Terms from "./site/pages/Terms";
import Login from "./site/pages/Login";
import Signup from "./site/pages/Signup";
import Account from "./site/pages/Account";
import PasswordReset from "./site/pages/PasswordReset";
import VerifyEmail from "./site/pages/VerifyEmail";
import NotFound from "./site/pages/NotFound";
import Card from "./site/pages/Card";
import LandingLayout from "./site/landing/LandingLayout";
import LandingHub from "./site/landing/LandingHub";
import LandingPage from "./site/landing/LandingPage";
import LandingContact from "./site/landing/LandingContact";
import WebsiteLanding from "./site/landing/WebsiteLanding";
import ShortLink from "./site/landing/ShortLink";

/* =========================================================
   I.META · 아이닷메타 — 공개 사이트 라우팅
   index.js 에서 /* 로 마운트되므로 하위 경로는 상대 경로로 둔다.
   ========================================================= */
/* 디지털 명함 주소 — /<slug>_businesscard (명함은 SSTOA '명함 관리'에서 등록) */
const CARD_PATH = /^\/([a-z0-9-]+)_businesscard\/?$/;

/* /apply?segment=… · ?gov=1 은 그대로 넘기고(개발 문의 페이지가 공동개발 문의를 골라 둔 채 열린다), 맨 주소는 공동개발 문의를 골라 둔다 */
function ApplyMoved() {
  const { search } = useLocation();
  return <Navigate to={search ? `/contact${search}` : PARTNER_LINK} replace />;
}

export default function App() {
  const { pathname } = useLocation();
  const card = CARD_PATH.exec(pathname);
  /* 라우터 경로는 한 마디 안에서 접미사를 나눠 받지 못하므로 여기서 먼저 고른다.
     헤더·푸터 없는 단독 페이지 (QR · NFC · 링크 전달용) */
  if (card) return <Card slug={card[1]} />;

  return (
    <Routes>
      {/* 세그먼트별 홍보 랜딩 — 짧은 헤더 + 고정 [문의하기] (site/landing) */}
      <Route element={<LandingLayout />}>
        <Route path="for" element={<LandingHub />} />
        <Route path="for/contact" element={<LandingContact />} />
        <Route path="for/website" element={<WebsiteLanding />} />
        <Route path="for/:slug" element={<LandingPage />} />
        <Route path="go/:code" element={<ShortLink />} />
      </Route>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="partnership" element={<Partnership />} />
        {/* 예전 프로젝트 제안 주소 — 개발 문의(공동개발 문의)로 합쳤다 */}
        <Route path="apply" element={<ApplyMoved />} />
        <Route path="funding" element={<Funding />} />
        {/* 서비스 — 제품개발(/partnership) · 웹사이트 개발 · 개발지원 */}
        <Route path="services" element={<Services />} />
        <Route path="services/product" element={<Navigate to="/partnership" replace />} />
        <Route path="services/website" element={<WebsiteService />} />
        <Route path="services/consulting" element={<ConsultingService />} />
        {/* 개발 분야별 — pcb-design · firmware · prototyping · esp32 · industrial (content.js TECH_SERVICES) */}
        <Route path="services/:slug" element={<TechService />} />
        {/* 콘셉트 문서 사이트맵 주소 — 기존 판매제품 · 자료실로 연결 */}
        <Route path="shop" element={<Navigate to="/products" replace />} />
        <Route path="learn" element={<Navigate to="/forum" replace />} />
        <Route path="resources" element={<Navigate to="/forum" replace />} />
        <Route path="works" element={<Works />} />
        <Route path="process" element={<Process />} />
        <Route path="about" element={<About />} />
        <Route path="forum" element={<ForumLayout />}>
          <Route index element={<Forum />} />
          <Route path=":id" element={<ForumPost />} />
        </Route>
        <Route path="products" element={<Products />} />
        <Route path="products/:slug" element={<ProductDetail />} />
        <Route path="cart" element={<Cart />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="my" element={<My />} />
        <Route path="contact" element={<Contact />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="account" element={<Account />} />
        <Route path="password-reset" element={<PasswordReset />} />
        <Route path="verify" element={<VerifyEmail />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
